import type { SVGProps } from 'react';

export const SvgIconDeleteKeyword = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16.2426 7.75733L7.75732 16.2426" strokeWidth="1.5" strokeLinejoin="round" stroke="currentColor" />
    <path d="M16.2426 16.2427L7.75732 7.75739" strokeWidth="1.5" strokeLinejoin="round" stroke="currentColor" />
  </svg>
);
